import React, {
  useEffect,
  useState,
} from "react";

import {
  Stack,
  Select,
  Text,
  NumberInput,
  NumberInputField,
} from "@chakra-ui/react";

import ReusableDrawer from "components/Drawers/ReusableDrawer";
import ReusableInput from "components/Inputs/ReusableInput";
import GradientButton from "components/Buttons/GradientButton";

import StatusBadge, {
  getStatusVariant,
} from "components/Badges/StatusBadge";

import { useDispatch } from "react-redux";

import {
  updateAgentTrainingAction,
  fetchAgentTrainingAction,
} from "state/actions/agentTrainingActions";

import { useCustomNotification } from "components/Toasts/OpenNotification";


const EditAgentTraining = ({
  isOpen,
  onClose,
  training,
}) => {

  const dispatch = useDispatch();

  const notify =
    useCustomNotification();


  const [formData, setFormData] =
    useState({

      title: "",

      description: "",

      content: "",

      video_url: "",

      material_url: "",

      display_order: 0,

      mandatory: true,

      status: "Active",

    });


  useEffect(() => {

    if (training) {

      setFormData({

        title:
          training.title || "",

        description:
          training.description || "",

        content:
          training.content || "",

        video_url:
          training.video_url || "",

        material_url:
          training.material_url || "",

        display_order:
          training.display_order ?? 0,

        mandatory:
          training.mandatory ?? true,

        status:
          training.status || "Active",

      });

    }

  }, [training]);


  const handleInputChange = (
    e
  ) => {

    const {
      name,
      value,
    } = e.target;

    setFormData(
      (prev) => ({
        ...prev,
        [name]: value,
      })
    );

  };


  const handleSave = async () => {

    if (!training?.training_id) {

      notify({
        message:
          "Training Missing",

        description:
          "Unable to identify the training material.",

        type:
          "error",
      });

      return;

    }


    if (!formData.title.trim()) {

      notify({
        message:
          "Title Required",

        description:
          "Please provide a training title.",

        type:
          "error",
      });

      return;

    }


    const payload = {

      title:
        formData.title,

      description:
        formData.description,

      content:
        formData.content,

      video_url:
        formData.video_url,

      material_url:
        formData.material_url,

      display_order:
        Number(
          formData.display_order
        ),

      mandatory:
        formData.mandatory,

      status:
        formData.status,

    };


    const response =
      await dispatch(
        updateAgentTrainingAction(
          training.training_id,
          payload
        )
      );


    if (response?.success) {

      notify({
        message:
          "Training Updated",

        description:
          "Training material updated successfully.",

        type:
          "success",
      });


      dispatch(
        fetchAgentTrainingAction(
          1,
          10
        )
      );


      onClose();

    } else {

      notify({
        message:
          "Failed to Update Training",

        description:
          response?.error ||
          "Something went wrong while updating the training.",

        type:
          "error",
      });

    }

  };


  return (

    <ReusableDrawer

      isOpen={isOpen}

      onClose={onClose}

      headerContent={
        <h2>
          Edit Agent Training
        </h2>
      }

      bodyContent={

        <Stack spacing={4}>

          <ReusableInput
            label="Title"
            name="title"
            value={
              formData.title
            }
            onChange={
              handleInputChange
            }
            placeholder="Enter training title"
            isRequired
          />


          <ReusableInput
            label="Description"
            name="description"
            value={
              formData.description
            }
            onChange={
              handleInputChange
            }
            placeholder="Enter training description"
            type="textarea"
          />


          <ReusableInput
            label="Content"
            name="content"
            value={
              formData.content
            }
            onChange={
              handleInputChange
            }
            placeholder="Enter training content"
            type="textarea"
          />


          <ReusableInput
            label="Video URL"
            name="video_url"
            value={
              formData.video_url
            }
            onChange={
              handleInputChange
            }
            placeholder="Enter video URL"
          />


          <ReusableInput
            label="Material URL"
            name="material_url"
            value={
              formData.material_url
            }
            onChange={
              handleInputChange
            }
            placeholder="Enter material URL"
          />


          <Stack spacing={2}>

            <Text
              fontSize="sm"
              color="gray.500"
            >
              Display Order
            </Text>

            <NumberInput
              min={0}
              value={
                formData.display_order
              }
              onChange={(value) =>
                setFormData(
                  (prev) => ({
                    ...prev,
                    display_order:
                      value,
                  })
                )
              }
            >

              <NumberInputField />

            </NumberInput>

          </Stack>


          <Stack spacing={2}>

            <Text
              fontSize="sm"
              color="gray.500"
            >
              Mandatory
            </Text>

            <Select
              value={
                String(
                  formData.mandatory
                )
              }
              onChange={(e) =>
                setFormData(
                  (prev) => ({
                    ...prev,
                    mandatory:
                      e.target.value ===
                      "true",
                  })
                )
              }
            >

              <option value="true">
                Yes
              </option>

              <option value="false">
                No
              </option>

            </Select>

          </Stack>


          <Stack spacing={2}>

            <Text
              fontSize="sm"
              color="gray.500"
            >
              Status
            </Text>

            <StatusBadge
              label={
                formData.status
              }
              variant={
                getStatusVariant(
                  formData.status
                )
              }
            />

            <Select
              value={
                formData.status
              }
              onChange={(e) =>
                setFormData(
                  (prev) => ({
                    ...prev,
                    status:
                      e.target.value,
                  })
                )
              }
            >

              <option value="Active">
                Active
              </option>

              <option value="Inactive">
                Inactive
              </option>

            </Select>

          </Stack>

        </Stack>
      }

      footerContent={

        <Stack
          direction="row"
          spacing={4}
          justifyContent="flex-end"
        >

          <GradientButton
            width="100px"
            height="40px"
            onClick={onClose}
          >
            Cancel
          </GradientButton>


          <GradientButton
            width="100px"
            height="40px"
            onClick={handleSave}
          >
            Save
          </GradientButton>

        </Stack>

      }

    />

  );

};


export default EditAgentTraining;